import { createApp } from "vue";
import App from "./App.vue";
import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./assets/main.css";
import { definePreset } from "@primeuix/themes";
import router from "@/router";

const app = createApp(App);

app.use(router);

const customAura = definePreset(Aura, {
  semantic: {
    colorScheme: {
      dark: {
        surface: {
          0: "#18181b",
        },
        primary: {
          color: "#caff01",
          inverseColor: "#000000",
          hoverColor: "#d6ff4d",
          activeColor: "#ceff26",
        },
        highlight: {
          background: "#caff01",
          focusBackground: "#d6ff4d",
          color: "#000000",
          focusColor: "#000000",
        },
      },
    },
  },
});

app.use(PrimeVue, {
  theme: {
    preset: customAura,
    options: {
      prefix: "p",
      darkModeSelector: ".dark-mode",
      cssLayer: false,
    },
  },
});

const webSiteConfig: WebSiteConfig = window.__APP_CONFIG__;

app.config.globalProperties.$webSiteConfig = webSiteConfig;

app.mount("#app");
